import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getNewbuildingByIdSelector } from '../../selectors/newbuilding/getNewbuildingByIdSelector';
import { EPageTypes, EPlatformTypes, SimpleCall } from '@cian/frontend-newbuilding-call-component';
import { useApplicationContext } from '../../utils/applicationContext';
import { usePhoneData } from './hooks/usePhoneData';
import { SinglePhoneComponent } from './SinglePhoneComponent';
import { trackingActionOpenContacts, trackingActionShowPhone } from '../../actions/analytics';
import { TTypedThunkDispatch } from '../../types/thunk';
import { isNewbuildingInLeadFactory } from '../../utils/helpers';

interface IPhoneButtonProps {
  newbuildingId: number;
}

export const PhoneButton = ({ newbuildingId }: IPhoneButtonProps) => {
  const { httpApi, logger } = useApplicationContext();
  const dispatch: TTypedThunkDispatch = useDispatch();

  const newbuilding = useSelector(getNewbuildingByIdSelector(newbuildingId));
  const isLeadFactory = isNewbuildingInLeadFactory(newbuilding);

  const { builders, sellers } = usePhoneData(newbuilding);
  const forcedShowModal = builders.length === 0 && sellers.length === 1 && !isLeadFactory;

  const trackingOnPhoneClick = () => {
    dispatch(trackingActionShowPhone(newbuilding));
  };
  const trackingOpenContacts = () => {
    dispatch(trackingActionOpenContacts(newbuilding.gaLabels.full));
  };

  const singlePhoneButtonText = isLeadFactory ? 'Контакты консультанта' : undefined;

  const multiplePhoneButtonText = React.useMemo(() => {
    if (isLeadFactory) {
      return 'Контакты консультанта';
    }

    if (builders.length > 0) {
      return 'Контакты застройщика';
    }

    return 'Контакты продавца';
  }, [isLeadFactory, builders.length]);

  /* istanbul ignore next */
  if (!builders.length && !sellers.length) {
    return null;
  }

  return (
    <SimpleCall
      SinglePhoneComponent={SinglePhoneComponent}
      openContactsStyles={{ size: 'M' }}
      showPhoneStyles={{ size: 'M' }}
      httpApi={httpApi}
      logger={logger}
      platformType={EPlatformTypes.WebDesktop}
      pageType={EPageTypes.NewbuildingList}
      placeType="ShowPhoneButton"
      builders={builders}
      sellers={sellers}
      onShowPhoneClick={trackingOnPhoneClick}
      onOpenContactsClick={trackingOpenContacts}
      forcedShowModal={forcedShowModal}
      singlePhoneButtonText={singlePhoneButtonText}
      multiplePhoneButtonText={multiplePhoneButtonText}
    />
  );
};
